import React from 'react';
const bonuses = [{
  num: 1,
  title: 'Errores comunes en enfermería',
  desc: 'Cómo evitarlos en la práctica',
  price: '$8.000 ARS'
}, {
  num: 2,
  title: 'Guía rápida de guardia',
  desc: 'Qué hacer en situaciones clave',
  price: '$7.000 ARS'
}, {
  num: 3,
  title: 'Farmacología simplificada',
  desc: 'Lo que necesitás recordar sí o sí',
  price: '$6.000 ARS'
}, {
  num: 4,
  title: 'Checklist clínico esencial',
  desc: 'Evitar errores antes de actuar',
  price: '$5.000 ARS'
}, {
  num: 5,
  title: 'Organización personal del enfermero/a',
  desc: 'Cómo manejar el turno sin colapsar',
  price: '$7.000 ARS'
}, {
  num: 6,
  title: 'Plan de acción en 7 días',
  desc: 'Para ganar seguridad rápidamente',
  price: '$6.000 ARS'
}];
export function BonusSection() {
  return <section className="bg-brand-dark text-white py-5 px-5" data-id="element-43">
      <div className="max-w-xl mx-auto" data-id="element-44">
        <div className="text-center mb-8" data-id="element-45">
          <h2 className="text-2xl md:text-3xl font-extrabold mb-2" data-id="element-46">
            🎁 PERO ESO NO ES TODO... RECIBE TAMBIÉN LOS 6 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-sm text-gray-400 font-medium" data-id="element-47">
            Incluidos en todas las ofertas
          </p>
        </div>

        <div className="space-y-3 mb-8" data-id="element-48">
          {bonuses.map(bonus => <div key={bonus.num} className="bg-white/5 border-2 border-yellow-400/50 rounded-xl p-5 relative overflow-hidden transition-all hover:border-yellow-400" data-id="element-49">
              {/* GRATIS badge */}
              <div className="absolute top-3 right-3 bg-red-600 text-white text-[10px] font-black px-2.5 py-1 rounded-md flex items-center gap-1" data-id="element-50">
                🎁 GRATIS
              </div>

              {/* Bono label */}
              <div className="flex items-center gap-3 mb-2" data-id="element-51">
                <div className="bg-brand-yellow/20 w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-52">
                  <span className="text-lg" data-id="element-53">🎁</span>
                </div>
                <span className="text-[11px] text-gray-500 font-bold uppercase tracking-wider" data-id="element-54">
                  BONO {bonus.num}
                </span>
              </div>

              {/* Title */}
              <h3 className="text-base font-black text-white mb-1 pr-16" data-id="element-55">
                {bonus.title}
              </h3>

              {/* Description */}
              <p className="text-xs text-gray-500 mb-3 leading-relaxed" data-id="element-56">
                {bonus.desc}
              </p>

              {/* Price */}
              <div className="flex items-center gap-2" data-id="element-57">
                <span className="text-sm text-gray-600 line-through" data-id="element-58">
                  {bonus.price}
                </span>
                <span className="text-sm font-black text-green-500" data-id="element-59">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="bg-white/5 border border-brand-yellow/30 rounded-xl p-6 text-center" data-id="element-60">
          <p className="text-gray-500 text-sm line-through mb-1" data-id="element-61">
            Valor total: +$39.000 ARS
          </p>
          <p className="text-2xl md:text-3xl font-black text-brand-yellow" data-id="element-62">
            🎁 HOY: GRATIS
          </p>
          <p className="text-xs text-gray-500 mt-1" data-id="element-63">
            (solo por tiempo limitado)
          </p>
        </div>
      </div>
    </section>;
}